
import React from 'react';

interface MapLoadingStateProps {
  message?: string;
}

const MapLoadingState: React.FC<MapLoadingStateProps> = ({ 
  message = "Loading map..." 
}) => {
  return (
    <div className="relative w-full h-full min-h-[400px] rounded-lg overflow-hidden bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-peach-orange mx-auto mb-2"></div>
        <span className="text-sm text-sunset-medium font-medium">{message}</span>
      </div>
    </div>
  );
};

export default MapLoadingState;
